import type { Client } from '@urql/core'
import { graphql } from 'app/generated/gql'

import type { ChannelMappingV2 as ChannelMappingType, ChannelMappingV2ListResult } from 'app/generated/graphql'
import { EntityStore } from './EntityStore'

const CHANNEL_MAPPING_FIELDS = `channel createdDate id medium orgId source updatedDate version workspaceId`

const LIST_QUERY = graphql(`
  query ChannelMappings($search: String, $pagination: PaginationInput, $sort: SortInput) {
    channelMappings(search: $search, pagination: $pagination, sort: $sort) {
      hits {
        channel
        createdDate
        id
        medium
        orgId
        source
        updatedDate
        version
        workspaceId
      }
      total
      page
    }
  }
`)

const CREATE_MUTATION = graphql(`
  mutation CreateChannelMappingStore($input: CreateChannelMappingInput!) {
    createChannelMapping(input: $input) {
      channel
      createdDate
      id
      medium
      orgId
      source
      updatedDate
      version
      workspaceId
    }
  }
`)

const UPDATE_MUTATION = graphql(`
  mutation UpdateChannelMappingStore($id: ID!, $input: UpdateChannelMappingInput!) {
    updateChannelMapping(id: $id, input: $input) {
      channel
      createdDate
      id
      medium
      orgId
      source
      updatedDate
      version
      workspaceId
    }
  }
`)

const DELETE_MUTATION = graphql(`
  mutation DeleteChannelMapping($id: ID!) {
    deleteChannelMapping(id: $id)
  }
`)

export class ChannelMappingStore extends EntityStore<
  ChannelMappingType,
  ChannelMappingV2ListResult,
  typeof CREATE_MUTATION,
  typeof UPDATE_MUTATION
> {
  constructor(client: Client) {
    super(client, {
      listQuery: LIST_QUERY,
      getQuery: undefined,
      createMutation: CREATE_MUTATION,
      updateMutation: UPDATE_MUTATION,
      deleteMutation: DELETE_MUTATION,
      typename: `ChannelMappingV2`,
      extractList: (data: any) => data.channelMappings,
      extractMutated: (data: any) => data.updateChannelMapping ?? data.createChannelMapping,
    })
  }
}
